import React from "react";
import { Group, Node } from "../../types";

type Props = {
  node: Node;
  fields: (JSX.Element | null)[] | undefined;
  phases: (JSX.Element | null)[] | undefined;
  index: number;
  type: Group;
};

/**
 * Used to create a single entry for a workflow or a dataset documentation.
 *
 * @author Juhana Kuparinen <juhana.kuparinen@kvanttori.fi>
 */

const ProcessInfo = ({ node, fields, phases, index, type }: Props) => {
  //id with nodename and index to deal with name collisions
  return (
    <section key={node.id}>
      <h2 id={`${node.name}-${index}`}>{node.name}</h2>
      <h3>Fields</h3>
      <table className="be_fields">
        <thead>
          <tr>
            <th>Name</th>
            <th>Type</th>
            <th>Description</th>
            <th>Placeholder</th>
            <th>Default Value</th>
            <th>Required</th>
            <th>Options</th>
            <th>Field ID</th>
          </tr>
        </thead>
        <tbody>{fields}</tbody>
      </table>
      <h3>{type === "dataset" ? "Categories" : "Phases"}</h3>
      <table className="be_fields">
        <thead>
          <tr>
            <th>Name</th>
            {type === "dataset" ? null : <th>Linked To</th>}
            <th>Phase ID</th>
          </tr>
        </thead>
        <tbody>{phases}</tbody>
      </table>
      <hr style={{ marginTop: "100px" }} />
    </section>
  );
};

export default ProcessInfo;
